import {
  PurchaseLoadGenqlSelection,
  PurchaseLoadLineItemGenqlSelection,
} from '@rematter/frontend-lib-api-client';

export const purchaseLoadLineItemFragment = {
  id: true,
  type: true,
  parentLineItemId: true,
  itemId: true,
  tagId: true,
  purchaseOrderLineId: true,
  grossWeight: {
    value: true,
    unit: true,
  },
  tareWeight: {
    value: true,
    unit: true,
  },
  netWeight: {
    value: true,
    unit: true,
  },
  unitPrice: {
    amount: true,
    currencyCode: true,
  },
  estimatedPrice: {
    amount: true,
    currencyCode: true,
  },
  pricingUnit: true,
  requiresSorting: true,
  settlementBasis: true,
  sortingWorkOrder: {
    id: true,
    status: true,
    workOrderNumber: true,
  },
  notes: true,
  vehicleVin: true,
  vehicleYear: true,
  vehicleMake: true,
  vehicleModel: true,
  vehicleTitleStatus: true,
  catSerialNumber: true,
  catOemCode: true,
  catComplianceStatus: true,
  item: {
    id: true,
    name: true,
  },
} satisfies PurchaseLoadLineItemGenqlSelection;

export const simplePurchaseLoadFragment = {
  id: true,
  status: true,
  documentNumber: true,
  receivedDate: true,
  description: true,
  currencyCode: true,
  heavyWeight: {
    value: true,
    unit: true,
  },
  lightWeight: {
    value: true,
    unit: true,
  },
  weightDisplayUnit: true,
  purchaseOrderId: true,
  purchaseOrder: {
    id: true,
    documentNumber: true,
  },
  facilityId: true,
  facility: {
    id: true,
    facilityName: true,
  },
  supplierAccountId: true,
  supplierAccount: {
    id: true,
    name: true,
  },
  timestamps: {
    createdAt: true,
    updatedAt: true,
  },
} satisfies PurchaseLoadGenqlSelection;

export const fullPurchaseLoadFragment = {
  ...simplePurchaseLoadFragment,
  containerTypeId: true,
  containerType: {
    id: true,
    name: true,
  },
  carrierAccountId: true,
  carrierAccount: {
    id: true,
    name: true,
  },
  freightCost: {
    amount: true,
    currencyCode: true,
  },
  freightTerms: true,
  bolNumber: true,
  shippingCarrierName: true,
  scac: true,
  driverName: true,
  truckNumber: true,
  trailerNumber: true,
  containerNumber: true,
  sealNumber: true,
  internalNotes: true,
  externalNotes: true,
  receivingTicketNumber: true,
  receivedTicketIssueDate: true,
  lineItems: purchaseLoadLineItemFragment,
  files: {
    id: true,
    fileName: true,
    fileSize: true,
    mimeType: true,
    fileType: true,
    metadata: true,
  },
  createdByUser: {
    id: true,
    firstName: true,
    lastName: true,
  },
} satisfies PurchaseLoadGenqlSelection;
